module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic18.7945faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic18.png
// module id = 517
// module chunks = 1